import React from 'react';
import './ExtraInfoContent.css';

interface InfoCard {
    id: number;
    title: string;
    description: string;
    icon?: {
        url: string;
        formats?: {
            thumbnail?: { url: string };
            small?: { url: string };
        };
    } | null;
}

interface ExtraInfoContentProps {
    title: string;
    description: string;
    infoCards: InfoCard[];
    buttonText: string;
    onContinue: () => void;
    mainBanner?: string | null;
    step: any;
    // Add other fields here as needed in the future
}

export const ExtraInfoContent: React.FC<ExtraInfoContentProps> = ({
    title,
    description,
    infoCards,
    buttonText,
    onContinue,
    mainBanner
}) => {
    return (
        <div className="extra-info">
            <div className="extra-info__header">
                {mainBanner && (
                    <div className="extra-info__main-banner">
                        <img src={mainBanner} alt="Main Banner" />
                    </div>
                )}
                <h2 className="extra-info__title">{title}</h2>
                <p className="extra-info__description">{description}</p>
            </div>
            <div className="extra-info__items">
                {infoCards.map((item) => (
                    <div key={item.id} className="extra-info__item">

                        <div className="extra-info__item-content">
                            <h3 className="extra-info__item-title">
                                {item.icon && item.icon.url && (
                                <div className="extra-info__item-icon">
                                    <img src={item.icon.formats?.small?.url || item.icon.formats?.thumbnail?.url || item.icon.url} alt={item.title} />
                                </div>
                            )}
                                {item.title}</h3>
                            <p className="extra-info__item-description">{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            {buttonText && (
                <div className="inform-selector__button-fixed">
            <button className="extra-info__continue-btn" onClick={onContinue}>
                {buttonText}
            </button>
                </div>)}
        </div>
    );
};
